/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByTypeOfProblemV2Kind = (typeof GroupByTypeOfProblemV2Kind)[keyof typeof GroupByTypeOfProblemV2Kind];

export const GroupByTypeOfProblemV2Kind = {
  type_of_problem_v2: 'type_of_problem_v2',
} as const;
